import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'translatePart' })
export class TranslatePartPipe implements PipeTransform {
  transform(value: string, index: number): string {
    return value.split('^^')[index] || '';
  }
}
